
import { clearAllCaches as clearAllClientCaches } from '@/utils/clientCacheUtils';
import { cacheEventBus } from './cache-event-bus';
import { cleanupClientCache, optimizeClientCache, getCacheOptimizationRecommendations } from './cache-optimization';
import { getAllCacheMetrics, getCacheHitRate, getCacheSizeMetrics, getCacheMetrics } from './cache-metrics';
import { invalidateCacheByTopic, invalidateCacheByLanguage, invalidateCacheByKnowledgeUpdate } from './cache-invalidation';

// Export clearAllCaches from clientCacheUtils for use in other components
export const clearAllCaches = clearAllClientCaches;

// Export constants for consistent store naming
export const EMBEDDING_STORE = 'embeddings';
export const RESPONSE_STORE = 'responses';
export const MESSAGES_STORE = 'messages';
export const CACHE_STATS_STORE = 'cache_stats';
export const CACHE_RELATIONSHIPS_STORE = 'cache_relationships';
export const CLIENT_CACHE_TTL = {
  EMBEDDING: 7 * 24 * 60 * 60 * 1000, // 7 days
  RESPONSE: 24 * 60 * 60 * 1000,      // 24 hours
  MESSAGES: 3 * 24 * 60 * 60 * 1000   // 3 days
};

// Re-export all the required functions and types
export {
  // Event bus
  cacheEventBus,
  
  // Cache operations
  cleanupClientCache,
  optimizeClientCache,
  
  // Cache invalidation
  invalidateCacheByTopic,
  invalidateCacheByLanguage,
  invalidateCacheByKnowledgeUpdate,
  
  // Cache metrics
  getAllCacheMetrics,
  getCacheMetrics,
  getCacheHitRate,
  getCacheSizeMetrics,
  getCacheOptimizationRecommendations
};

// From embedding-cache.ts
export { getClientEmbedding, setClientEmbedding } from './embedding-cache';

// From response-cache.ts
export { getClientResponse, setClientResponse, debugResponseCache } from './response-cache';

// From message-cache.ts
export { getClientMessages, setClientMessages, syncClientCache } from './message-cache';

// From cache-utils.ts
export { trackContentRelationship, getRelatedContentKeys } from './cache-utils';

// Cache initialization with enhanced setup
export const initializeClientCache = (): void => {
  // Clean up expired items on startup
  cleanupClientCache().catch(console.error);
  
  // Set up periodic cleanup (every hour)
  setInterval(() => {
    cleanupClientCache().catch(console.error);
  }, 60 * 60 * 1000);
  
  // Set up periodic cache optimization (every 6 hours)
  setInterval(() => {
    optimizeClientCache().catch(console.error);
  }, 6 * 60 * 60 * 1000);
  
  // Set up listeners for cache invalidation events
  setupCacheEventListeners();
};

// Setup cache event listeners
function setupCacheEventListeners(): void {
  // Listen for knowledge base updates
  cacheEventBus.subscribe('knowledgeUpdated', (payload) => {
    console.log(`Knowledge base updated (ID: ${payload.knowledgeId}), invalidating related cache entries`);
    // Additional logic if needed
  });
  
  // Listen for topic updates
  cacheEventBus.subscribe('topicUpdated', (payload) => {
    console.log(`Topic updated (${payload.topic}), ${payload.invalidatedCount} cache entries invalidated`);
  });
}
